import { useQuery } from 'react-query'

import { useUserProvider } from '../../components/Context/UserContext'
import { CacheKeys } from '../../helpers/cacheKeys'
import { ApiVersion } from '../../models'
import { getAvailableTags, NoteRecordType } from '../../models/note'

interface UseNoteAvailabelTags {
  recordType: NoteRecordType
  recordId: string
  apiVersion?: ApiVersion
}

export function useNoteAvailableTags(
  { recordType, recordId, apiVersion }: UseNoteAvailabelTags,
  { enabled = true } = {}
) {
  const { loggedInUser } = useUserProvider()

  const { data, isLoading, isFetching, refetch } = useQuery(
    `${CacheKeys.NOTE_AVAILABLE_TAGS}-${recordType}-${recordId}-${loggedInUser?.id}`,
    () => getAvailableTags({ recordType, recordId, apiVersion }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      enabled,
    }
  )

  return {
    tags: data?.tags || [],
    refetch,
    isLoading,
    isFetching,
  }
}
